import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, trackPageview } from "@/lib/analytics";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    setConsent("accepted");
    setVisible(false);
    trackPageview(window.location.pathname);
  };

  const handleDecline = () => {
    setConsent("declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[1000] bg-rr-navy text-white rounded-2xl shadow-2xl p-5 border border-white/10"
        >
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-xl bg-rr-orange/20 text-rr-orangeLight flex items-center justify-center shrink-0">
              <Cookie size={18} />
            </div>
            <div>
              <p className="text-sm font-bold">We use privacy-first analytics</p>
              <p className="text-xs text-white/60 mt-1.5 leading-relaxed">
                We track anonymous pageviews and section engagement on our own servers — never sold or shared with third
                parties. Read our{" "}
                <Link to="/legal/cookie-policy" className="underline hover:text-rr-orangeLight">
                  Cookie Policy
                </Link>
                .
              </p>
            </div>
          </div>
          <div className="flex gap-2.5 mt-4">
            <button
              onClick={handleDecline}
              data-testid="cookie-consent-decline"
              className="flex-1 text-xs font-bold py-2.5 rounded-full border border-white/20 hover:bg-white/10 transition-colors"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              data-testid="cookie-consent-accept"
              className="flex-1 text-xs font-bold py-2.5 rounded-full bg-rr-orange hover:bg-rr-orangeLight transition-colors"
            >
              Accept
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
